<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
    maximized
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="aprobarRendicion()">
        <!-- <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Aprobar Rendición</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section> -->
        <!-- Items de la solicitud -->
        <q-card-section class="text-center text-white">
          <strong>ITEMS SOLICITUD</strong>
        </q-card-section>
        <q-separator class="bg-pragma"></q-separator>
        <q-card-section class="q-pa-none">
          <div class="row">
            <div class="col-xs-12 text-white q-px-xs">
              <q-list>
                <q-expansion-item
                  dense
                  dense-toggle
                  expand-separator
                  label="ítem de la solicitud"
                  class="text-bold q-pb-md"
                >
                  <q-list separator bordered v-if="solicitud.modalidad_id == 1 || solicitud.modalidad_id == 2" class="q-px-md">
                    <q-item
                      clickable
                      v-ripple
                      v-for="(item, index) in solicitud.items"
                      :key="item.id"
                      @click="verDetalleItem(item)"
                      :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                    >
                      <q-item-section>
                        <q-item-label class="text-white">{{item.detalle}}</q-item-label>
                        <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                  <q-list separator bordered v-if="solicitud.modalidad_id == 3 || solicitud.modalidad_id == 4" class="q-px-md">
                    <q-item
                      clickable
                      v-ripple
                      v-for="(item, index) in solicitud.items_rendidos"
                      :key="item.id"
                      @click="verDetalleItem(item)"
                      :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                    >
                      <q-item-section>
                        <q-item-label>{{item.detalle}}</q-item-label>
                        <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-expansion-item>
              </q-list>
            </div>
          </div>
        </q-card-section>
        <!-- Items de la solicitud -->
        <q-card-section class="text-center text-white">
          <strong>ITEMS RENDIDOS</strong>
        </q-card-section>
        <q-separator class="bg-pragma"></q-separator>
        <q-card-section class="q-pa-none">
          <div class="row">
            <div class="col-xs-12 text-white q-px-xs">
              <q-list>
                <q-expansion-item
                  dense
                  dense-toggle
                  expand-separator
                  label="ítem de la solicitud"
                  class="text-bold q-pb-md"
                >
                  <q-list separator bordered v-if="solicitud.modalidad_id == 1 || solicitud.modalidad_id == 2" class="q-px-md">
                    <q-item
                      clickable
                      v-ripple
                      v-for="(item, index) in solicitud.items_rendidos"
                      :key="item.id"
                      @click="verDetalleItem(item)"
                      :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                    >
                      <q-item-section>
                        <q-item-label class="text-white">{{item.detalle}}</q-item-label>
                        <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                  <q-list separator bordered v-if="solicitud.modalidad_id == 3 || solicitud.modalidad_id == 4" class="q-px-md">
                    <q-item
                      clickable
                      v-ripple
                      v-for="(item, index) in solicitud.items_rendidos"
                      :key="item.id"
                      @click="verDetalleItem(item)"
                      :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                    >
                      <q-item-section>
                        <q-item-label>{{item.detalle}}</q-item-label>
                        <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-expansion-item>
              </q-list>
            </div>
          </div>
        </q-card-section>
        <q-separator class="bg-pragma"></q-separator>
        <!-- Documentos -->
        <q-card-section v-if="solicitud.documentos_rendicion.length > 0" class="q-pa-none">
          <div class="row q-py-sm text-white">
            <div class="col-xs-12 q-px-xs">
              <q-list>
                <q-expansion-item
                  dense
                  dense-toggle
                  expand-separator
                  label="Documentos adjuntos"
                  class="text-bold"
                >
                  <q-list>
                    <q-item
                      clickable
                      v-ripple
                      v-for="documento in solicitud.documentos_rendicion"
                      :key="documento.id"
                      @click="verDocumento(documento)"
                    >
                      <q-card style="width: 100%" class="text-caption">
                        <q-card-section class="bg-grey-9 text-white">
                          <div class="row full-width">
                            <div class="col-xs-2">
                              <q-icon name="attach_file" size="sm"></q-icon>
                            </div>
                            <div class="col-xs-10 wrap">
                              <span style="word-break: break-all">{{documento.direccion}}</span>
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>
                    </q-item>
                  </q-list>
                </q-expansion-item>
              </q-list>
            </div>
          </div>
        </q-card-section>
        <q-card-section class="text-center">
          <div class="row">
            <div class="col-xs-12">
              <q-checkbox
                v-model="observar"
                label="¿Desea realizar alguna observación?"
                dark
              ></q-checkbox>
            </div>
            <div class="col-xs-12" v-if="observar">
              <q-input
                v-model="observacion"
                type="textarea"
                label="Describa sus observaciones"
                class="tu"
                autogrow
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="Cancelar"
                color="negative"
                icon="clear"
                class="full-width"
                @click="closeDialog()"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="Aprobar"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
import util from '../../../../plugins/util'
import env from '../../../../../config/env'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const $q = useQuasar()
    
    const dialog = ref(false)
    const solicitud= ref(null)
    const observar = ref(false)
    const observacion = ref('')
    const loading = ref(false)

    // Métodos y funciones
    const aprobarRendicion = async () => {
      try {
        loading.value = true
        if (observar.value) {
          await axios.get(`/solicitud-aprobar-rendicion?id_sol=${solicitud.value.id}&obs=${observacion.value}&platform=${util.getPlatform()}`)
        } else {
          await axios.get(`/solicitud-aprobar-rendicion?id_sol=${solicitud.value.id}&obs=SO&platform=${util.getPlatform()}`)
        }
        $q.notify({
          message: 'Rendición aprobada',
          color: 'positive'
        })

        // Reseteo de variables
        observacion.value = ''
        solicitud.value = null
        loading.value = false
        observar.value = false
        bus.emit('closeDialogEventoAutorizar')
        closeDialog()
      } catch (error) {
        loading.value = false
        return console.log(error)
      }
    }

    const verDetalleItem = (item) => {
      bus.emit('openDialogDetalleItemSolicitud', item)
    }

    const verDocumento = (documento) => {
      let url_file = `${env.SERVER_URL}empresas/${documento.empresa_slug}/${documento.gestion}/rendicion/${documento.direccion}`
      bus.emit('openDialogViewFile', url_file)
    }

    const closeDialog = () => {
      solicitud.value = null
      loading.value = false
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogAprobarRendicionSolicitud', (data) => {
      solicitud.value = data.solicitud
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      loading,
      closeDialog,
      aprobarRendicion,
      solicitud,
      util,
      verDetalleItem,
      verDocumento,
      observar,
      observacion
    }
  }
}
</script>

<style>

</style>